import { useAuth } from 'context/AuthContext';
import { useLanguage } from 'context/LanguageContext';
import { userFullName } from "../../utils/userFullName";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompress, faExpand, faFile, faHammer, faNewspaper, faUser } from '@fortawesome/free-solid-svg-icons';
import useFullScreen from 'hooks/useFullScreen';
import fullScreen from '../../utils/fullScreen';
import SearchButton from "components/ui/SearchButton";
import { useNavigate } from 'react-router-dom';
import wabysLogo from "../../assets/wabys.png";

const WisdomDashboardNavbar = ({ wisdomData, selectedOrg, setPopupPage, setClassRoomDetailsPopup, handleSelectOrganization }) => {
    // React Tools
    const navigate = useNavigate();
    // Custom Tools
    const { userInfo } = useAuth();
    const { language } = useLanguage(false);
    const isFullScreen = useFullScreen();

    return (
        < div className="relative w-full h-[25vh] md:h-[12vh] flex flex-col md:flex-row justify-between items-center bg-white md:px-[32px]" style={{
            boxSizing: 'border-box',
            zIndex: 20,
            borderBottom: '1px solid #222',
        }
        }>
            {/* WABYS and Wisdom logo */}
            < div className="flex items-center gap-6 my-2 md:ml-8" >
                <img className="w-[100px] md:w-[120px] lg:w-[120px] cursor-pointer rounded-xl" src={wabysLogo} alt="Wabys Logo" onClick={() => userInfo?.code !== 1452 && userInfo?.code !== 1476 ? navigate('/wabys') : navigate('/login')} />
                <div className='border-l-2 border-black p-1 h-6' />
                {
                    (userInfo.organization_id === 49 || userInfo.organization_id === 50 || userInfo.organization_id === 51 || userInfo.organization_id === 52 || userInfo.organization_id === 53 || userInfo.organization_id === 54 || userInfo.organization_id === 55 || selectedOrg?.id === 49 || selectedOrg?.id === 50 || selectedOrg?.id === 51 || selectedOrg?.id === 52 || selectedOrg?.id === 53 || selectedOrg?.id === 54 || selectedOrg?.id === 55) ?
                        <div className="flex items-center">
                            <img className="w-[60px]" src={require('../../assets/maslaha.png')} alt="Maslaha Logo" />
                            <div className='border-l-2 border-black p-1 h-6' />
                            {(userInfo.organization_id === 49 || userInfo.organization_id === 50 || selectedOrg?.id === 49 || selectedOrg?.id === 50) ?
                                <img className="w-[60px]" src={require('../../assets/shobrasena3a.png')} alt="shobra sena3a Logo" /> :
                                (userInfo.organization_id === 52 || selectedOrg?.id === 52) ?
                                    <img className="w-[60px]" src={require('../../assets/al3abasya.jpeg')} alt="shobra sena3a Logo" /> :
                                    (userInfo.organization_id === 54 || selectedOrg?.id === 54) ?
                                        <img className="w-[60px]" src={require('../../assets/korySayarat.jpeg')} alt="shobra sena3a Logo" /> :
                                        (userInfo.organization_id === 55 || selectedOrg?.id === 55) ?
                                            <img className="w-[60px]" src={require('../../assets/ameria.jpeg')} alt="shobra sena3a Logo" /> :
                                            (userInfo.organization_id === 51 || selectedOrg?.id === 51) ?
                                                <img className="w-[60px]" src={require('../../assets/shobrama3adntabreed.jpeg')} alt="shobra sena3a Logo" /> :
                                                (userInfo.organization_id === 53 || selectedOrg?.id === 53) ?
                                                    <img className="w-[60px]" src={require('../../assets/mezalat.jpeg')} alt="shobra sena3a Logo" /> : null
                            }
                        </div> :
                        <div className="flex items-center">
                            <img className="w-[60px]" src={require('../../assets/maslaha.png')} alt="Maslaha Logo" />
                        </div>
                }
            </div >
            <div className="flex items-center gap-4 relative flex-wrap justify-evenly">
                {/* Workshop tool sheet */}
                <button onClick={() => setClassRoomDetailsPopup(true)} className={`rounded-full w-9 h-9 px-2 font-bold flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all text-black `}>
                    <FontAwesomeIcon icon={faHammer} className="text-lg text-watomsBlue" />
                </button>
                <SearchButton
                    items={Object.entries(wisdomData.organizations).map(
                        (org) => org[1].name
                    )}
                    onSelect={handleSelectOrganization}
                />
                {/* CRO Score */}
                <button onClick={() => setPopupPage("cro report 2")} className={`rounded-full w-9 h-9 px-2 font-bold flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all text-black `}>
                    <FontAwesomeIcon icon={faNewspaper} className="text-lg text-watomsBlue" />
                </button>
                {/* CRO Score */}
                <button onClick={() => setPopupPage("cro report 1")} className={`relative rounded-full w-9 h-9 px-2 font-bold flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all text-black `}>
                    {/* <div className="absolute -top-1 -right-3 bg-red-600 text-white rounded-full w-5 h-5 text-sm">{filteredCroData.reduce((acc, obj) => acc + obj?.reports?.length, 0) || 0}</div> */}
                    <FontAwesomeIcon icon={faFile} className="text-lg text-watomsBlue" />
                </button>
                {/* Full Screen */}
                <button
                    onClick={fullScreen}
                    className="rounded-full w-9 h-9 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                    title={language ? (isFullScreen ? 'Exit Full Screen' : 'Enter Full Screen') : (isFullScreen ? 'خروج من الشاشة الكاملة' : 'دخول الشاشة الكاملة')}
                >
                    <FontAwesomeIcon
                        icon={isFullScreen ? faCompress : faExpand}
                        className="text-lg text-watomsBlue"
                    />
                </button>
                {/* User Name */}
                <span className="flex items-center gap-2 font-bold md:min-w-[100px] min-w-[300px] justify-center text-watomsBlue">
                    <FontAwesomeIcon icon={faUser} />
                    {userFullName(userInfo, language)}
                </span>
            </div>
        </div >
    )
};

export default WisdomDashboardNavbar;